import { useState, useEffect } from "react";
import { openTarget, redirectToLink, generateHorseProfileUrl, paddingNum, getSearchParams, generateUrl, setRacesDetailLoading } from "@/app/utils/Common";
import { LANGTYPE_EN, LangType, useLanguage } from "@/app/utils/LanguageContext";
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import styled from "styled-components";
import { GET_RACING_CHANGES } from "@/app/utils/request/query";
import { getRacingChanges } from "@/app/utils/request/requestList";
import { useMyContext } from "@/app/utils/MyContext";
import _ from 'lodash';
import moment from "moment";
import { formattedDate, dateFormat, toDate } from "@/app/utils/DayJS";
import { textSize, text_size } from "@/app/utils/MixinSize";
import NoInformation from "@/app/ui/Common/NoInformation";
import { MenuTab } from "@/app/utils/class/common/base";
import { menuTabSet } from "@/app/utils/constant/menuTabSet";
import { useLoading } from "@/app/utils/LoadingContext";

const ChangesTitle = styled.div`
  width: 100%;
  height: 36px;
  line-height: 16px;
  padding: 10px 12px;
  ${text_size(15)}
  font-weight: 500;
  background-color: #F4F4F4;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 10%);
`;

const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.root}`]: {
        color: "#333333",
    },
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#E1E1E1",
        fontWeight: 400,
        padding: "8px 0px 8px 8px",
        ...textSize(11),
        textAlign: "left",
        height: "32px",
        lineHeight: "16px",
        borderBottom: "0px",
      },
    [`&.${tableCellClasses.body}`]: {
        color: "#333333",
        ...textSize(13),
        fontWeight: 500,
        padding: "4px 0px 4px 8px",
        verticalAlign: "baseline",
        textAlign: "left",
        height: "32px",
        lineHeight: "24px"
    },
}));


const StyledTableHead = styled(TableRow)(() => ({
    'th,td': {
        border: 0,
        ...textSize(11),
        lineHeight: "16px",
    },
    'th:last-child, td:last-child': {
        paddingRight: "8px",
        paddingLeft: "12px",
        paddingTop: "8px",
        paddingBottom: "8px",
    },
    'th:first-child, td:first-child': {
        width: "16%",
        paddingRight: "8px",
        paddingLeft: "12px",
        paddingTop: "8px",
        paddingBottom: "8px",
    }
}));

const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(even)': {
        backgroundColor: "#F4F4F4",
    },
    '&:nth-of-type(odd)': {
        backgroundColor: "#FFFFFF",
    },
    'td': {
        border: 0,
        ...textSize(13),
        lineHeight: "18px",
    },
    'td:last-child': {
        paddingRight: "8px",
        paddingLeft: "12px",
        paddingTop: "8px",
        paddingBottom: "8px",
    },
    'td:first-child': {
        width: "16%",
        paddingRight: "0px",
        paddingLeft: "12px",
        paddingTop: "8px",
        paddingBottom: "8px",
        color: "#122C68",
    }
}));

const StyledLink = styled(Link)(() => ({
    [`&.MuiLink-root`]: {
        ...textSize(13),
        color: "#122C68",
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
            textDecorationColor: "#122C68",
            cursor: "pointer",
        }
    }
}));


interface propType {
  setRacesDetailLoading: (loading: boolean) => void;
    type?: string;
}


interface propRowType {
    rowChanges?: any;
}

interface propRowType1 {
    data?: any;
    msg?: string;
}


const translateChangesItem = (t:any, item:any, langType:LangType) => {
    let msg = "";
    let lang = (langType === LANGTYPE_EN ? 'en' : 'ch');
    console.log('item.type',item.type,t,item,langType);
    switch (item.type) {
        case "92":
            msg = t('changes_92')
                .replace('{runnerNo}', item.runnerNo)
                //.replace('{horseName}', item["horseName_" + lang] + "");
            break;
        case "96":
            msg = t('changes_96')
                .replace('{runnerNo}', item.runnerNo)
                .replace('{scratchHorseName}', '{horseName}')
                .replace('{horseName2}', item["horseName_" + lang]);
            break;
        case "98":
            msg = t('changes_98')
                .replace('{runnerNo}', item.runnerNo)
                //.replace('{horseName}', item["horseName_" + lang])
                .replace('{handicapWeight}', item.handicapWeight);
            break;
        case "99":
            msg = t('changes_99')
                .replace('{runnerNo}', item.runnerNo)
                //.replace('{horseName}', item["horseName_" + lang])
                .replace('{jockeyName}', item["jockeyName_" + lang]);
            break;
        case "169":
            msg = t('changes_169')
                .replace('{runnerNo}', item.runnerNo)
                //.replace('{horseName}', item["horseName_" + lang]);
            break;
        case "400":
            msg = t('changes_400')
                .replace('{runnerNo}', item.runnerNo)
                .replace('{reserve}', "R"==item.scrResvIndicator ? t('changes_reserve'): "")
                //.replace('{horseName}', item["horseName_" + lang]);
            break;
    }
    return msg + formattedDate(toDate(item.time || '', [dateFormat.qids.datetimeWithMs, dateFormat.qids.datetime]), "(DD/MM HH:mm)");
}

const getHorseId = (races:any, raceNo:number, runnerNo:string, langType:string) => {
    
    const runners = races.filter((x:any) => x.no === raceNo)?.[0].runners;
    const runner = runners.filter((y:any) => y.no === runnerNo)?.[0]

    console.log("racesData",runners,runner);
    if(runner)
    {
        return runner.id
    }

    return '';
}

const compareDate = (a: any) => {
    return moment(a.time).format('YYYY-MM-DDTHH:mm');
}

const compareType: any = (a: any) => {
    const typeMap = {"169": 1, "96": 2, "400": 3, "92": 4, "99": 5, "98": 6};
    return typeMap[a.type as keyof typeof typeMap];
}



const Changes: React.FC<propType> = (props: propType) => {
    const {completeLoading} = useLoading();
    const [changesData, setChangesData] = useState<any>(null);
    const [racesData, setRacesData] = useState<any>(null);
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));

    const { state: lang } = useLanguage();
    const { t } = lang;

    const onClick_horse = (row: any)=>{
        const horseID = getHorseId(racesData, row.raceNo, row.runnerNo, lang.langType);
        const url = generateHorseProfileUrl(
                lang.langCode, 
                myContextState.selectedMeetingDate, 
                myContextState.selectedMeeting?.meetingVenueCode || '', 
                row.raceNo, 
                horseID, 
                row.runnerNo);
    
        redirectToLink(url, openTarget("_blank")); 
    }
    const onClick_race = (raceNo: any)=>{
        const url = generateUrl(`/${encodeURIComponent(new MenuTab(menuTabSet.RACE_CARD).valueOf())}`, {
            'RaceDate': formattedDate(myContextState.selectedMeetingDate, "YYYYMMDD"),
            'Racecourse': myContextState.selectedMeetingVenueCode,
            'RaceNo': raceNo
        }, false, false, lang.langCode)
        redirectToLink(url, openTarget("_self")); 
    }


    useEffect(() => {
        const venueCode = myContextState.selectedMeetingVenueCode;
        if(venueCode==='') {
            setRacesDetailLoading(props.setRacesDetailLoading)
            completeLoading('page');
            return
        }
        const meetingDate = formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD");

        // const meetingDate = "2023-02-26";
        // const venueCode = "S2";

        getRacingChanges(
          {
            date: meetingDate,
            venueCode: venueCode
          },
          GET_RACING_CHANGES,
          "qids"
        )
          .then((res: any) => {
            const changeHistories = res?.raceMeetingProfile?.[0]?.changeHistories;
            const returnDate = res?.raceMeetingProfile?.[0]?.date;
            const returnVenueCode = res?.raceMeetingProfile?.[0]?.venueCode;
        
            if(returnDate ===meetingDate && returnVenueCode ===venueCode)
            {
                setChangesData(changeHistories.filter((x:any)=> filterChangeItems(x)));
                setRacesData(res?.raceMeetingProfile?.[0].races);
            }else
            {
                setChangesData(null);
            }
          })
          .catch((e: any) => {
            console.log(e);
          }).finally(() => {
            setRacesDetailLoading(props.setRacesDetailLoading)
            completeLoading('page');
          });
      }, [myContextState.selectedMeeting, myContextState.selectedRace]);

    const filterChangeItems = (item: any)=>{
        switch (item.type) {
            case "92":
            case "96":
            case "400":
            case "98":
            case "99":
                return true;
            case "169":
                if ("N"==item.scrResvIndicator) {
                    return true;
                }
                break;
        }
        return false;
    }

    const ChangesDescription: React.FC<propRowType> = (props: propRowType) => {

        const changes = props.rowChanges || [];
        if(props.rowChanges.length === 0)
            return (<StyledTableCell><p>--</p></StyledTableCell>)
        
        _.forEach(changes, function(item) {
            item.orderBy = paddingNum(item.runnerNo);
        })
        
        const changesOrderByType = _.orderBy(changes, [compareType], ["asc"]);
        const changesOrderByDate = _.orderBy(changesOrderByType, [compareDate], ["asc"]);
        const changesOrder = _.orderBy(changesOrderByDate, ["orderBy"], ["asc"]);

        return (
            <StyledTableCell>
                {changesOrder.map((row:any, indexChange:number) => (
                    <p key={indexChange}>
                        <ChangesDescriptionWithLink msg={translateChangesItem(t, row, lang.langType)} data={row}></ChangesDescriptionWithLink>
                    </p>
                ))}

            </StyledTableCell>
        )
    }

    const ChangesDescriptionWithLink: React.FC<propRowType1> = (props: propRowType1) => {
        const msgs = props.msg?.split('{horseName}') || [];
        if(msgs?.length<2) return <></>

        let horseName = lang.langType === LANGTYPE_EN ? props.data.horseName_en :props.data.horseName_ch;
        if(props.data.type==="96")
            horseName= lang.langType === LANGTYPE_EN ? props.data.scratchHorseName_en :props.data.scratchHorseName_ch;

        return (
            <>
                {
                    <p>
                        <>{msgs[0]}</>
                        <StyledLink onClick={()=>onClick_horse(props.data)}>{horseName}</StyledLink>
                        <>{msgs[1]}</>
                    </p>
                    
                }

            </>
        )
    }

    return (
        <>
            {props.type === "pc" ? (
                <div>
                    {changesData ? <><ChangesTitle id="changes_Title"> {t('changes_title')} </ChangesTitle><TableContainer id="changes_Table" sx={{ display: "flex", borderRadius: "0px 0px 4px 4px", boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)" }}>
                        <Table sx={{ width: "100%" }} aria-label="simple table">
                            <StyledTableHead id="changes_TableHead_pc">
                                <StyledTableCell sx={{backgroundColor: "#E1E1E1"}}>
                                    {t('changes_race')}
                                </StyledTableCell>
                                <StyledTableCell sx={{backgroundColor: "#E1E1E1"}}>
                                    {t('changes_description')}
                                </StyledTableCell>
                            </StyledTableHead>
                            <TableBody>
                                {racesData?.map((row:any, index:number) => (
                                    <StyledTableRow key={`changes_Row_${index}`} id={`changes_Row_${index}`}>
                                        <StyledTableCell>
                                            {<StyledLink onClick={()=>onClick_race(row.no)}>{t('changes_race_no').replace('{0}',row.no)}</StyledLink>}
                                        </StyledTableCell>
                                        <ChangesDescription rowChanges={changesData.filter((x: any) => x.raceNo == row.no)}></ChangesDescription>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer></>
                    : <NoInformation></NoInformation>
                    }
                </div>
            ) : (
                <div style={{ borderRadius: "0px 0px 4px 4px", boxShadow: "0px 2px 10px 0px rgb(0 0 0 / 10%)" }}>
                    {changesData ? <TableContainer id="changes_Mobile_Table" sx={{ borderRadius: "0px 0px 4px 4px", display: "flex" }}>
                        <Table sx={{ width: "100%" }} aria-label="simple table">
                            <StyledTableHead id="changes_TableHead_mobile">
                                <StyledTableCell sx={{backgroundColor: "#E1E1E1"}}>
                                    {t('changes_race')}
                                </StyledTableCell>
                                <StyledTableCell sx={{backgroundColor: "#E1E1E1"}}>
                                    {t('changes_description')}
                                </StyledTableCell>
                            </StyledTableHead>
                            <TableBody>
                            {racesData?.map((row:any, index:number) => (
                                    <StyledTableRow key={`changes_Row_${index}`} id={`changes_Row_${index}`}>
                                        <StyledTableCell>
                                        {<StyledLink onClick={()=>onClick_race(row.no)}>{t('changes_race_no').replace('{0}',row.no)}</StyledLink>}
                                        </StyledTableCell>
                                        <ChangesDescription rowChanges={changesData.filter((x: any) => x.raceNo == row.no)}></ChangesDescription>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    : <NoInformation></NoInformation>
                    }
                </div>
            )
            }
        </>
    )
}

export default Changes; 